export default __webpack_public_path__ + "static/media/a3.28b689e6.png";